import { Alert } from "@chakra-ui/alert";
import { AlertIcon, Link, VStack } from "@chakra-ui/react";
import { FormikErrors } from "formik";
import React from "react";
import { flattenObject } from "../../utils";

const ErrorSummary: React.FC<{
  errors: FormikErrors<any>;
}> = (props) => {
  const { errors } = props;
  if (!errors) {
    return null;
  }

  const flatErrors = flattenObject(errors) as { [key: string]: string };

  return (
    <VStack spacing={2} align="stretch">
      {Object.keys(flatErrors).map((key) => (
        <ErrorItem key={key} path={key} message={flatErrors[key]} />
      ))}
    </VStack>
  );
};

const ErrorItem: React.FC<{ path: string; message: string }> = ({
  message,
  path,
}) => {
  return (
    <Alert status="error">
      <AlertIcon />
      <Link
        href="#"
        onClick={(e) => {
          e.preventDefault();
          focusInputByName(path);
        }}
      >
        {message}
      </Link>
    </Alert>
  );
};

function focusInputByName(name: string) {
  const el = window.document.querySelector(`[name="${name}"]`)?.parentElement;
  // Doesn't work well with labels.
  if (el && "scrollIntoView" in el) {
    el.scrollIntoView({ behavior: "smooth" });
  }
}

export default ErrorSummary;
